export const CARD_STAT_KINDS = Object.freeze({
  wears: 'wears',
  compliments: 'compliments',
  lastWorn: 'last_worn',
  bottles: 'bottles',
  duration: 'duration',
})

export const CARD_SECONDARY_LINES = Object.freeze({
  firstWear: 'first_wear',
  earlyFavorite: 'early_favorite',
  firstCompliment: 'first_compliment',
  gettingNoticed: 'getting_noticed',
})

function wholeCount(value) {
  const count = Number(value)
  return Number.isFinite(count) ? Math.max(0, Math.trunc(count)) : 0
}

function confidenceSecondary(count, first, early) {
  if (count === 1) return first
  if (count >= 2 && count <= 4) return early
  return null
}

// Home-card metadata is deliberately data, not authored copy. Every taxonomy
// facet supplies this same shape and the shared card owns all wording/icons.
export function wearCardStats(value) {
  const count = wholeCount(value)
  return {
    primaryStat: { kind: CARD_STAT_KINDS.wears, value: count },
    secondaryLine: confidenceSecondary(
      count,
      CARD_SECONDARY_LINES.firstWear,
      CARD_SECONDARY_LINES.earlyFavorite,
    ),
  }
}

export function complimentCardStats(value) {
  const count = wholeCount(value)
  return {
    primaryStat: { kind: CARD_STAT_KINDS.compliments, value: count },
    secondaryLine: confidenceSecondary(
      count,
      CARD_SECONDARY_LINES.firstCompliment,
      CARD_SECONDARY_LINES.gettingNoticed,
    ),
  }
}

export function lastWornCardStats(value) {
  return {
    primaryStat: { kind: CARD_STAT_KINDS.lastWorn, value: String(value || 'Recently') },
    secondaryLine: null,
  }
}

export function bottleCardStats(value) {
  return {
    primaryStat: { kind: CARD_STAT_KINDS.bottles, value: Math.max(1, wholeCount(value)) },
    secondaryLine: null,
  }
}

export function durationCardStats(seconds) {
  return {
    primaryStat: { kind: CARD_STAT_KINDS.duration, value: Math.max(0, Number(seconds) || 0) },
    secondaryLine: null,
  }
}

export function primaryStatText(stat) {
  const value = stat?.value
  switch (stat?.kind) {
    case CARD_STAT_KINDS.wears:
      return `${wholeCount(value)} ${wholeCount(value) === 1 ? 'wear' : 'wears'}`
    case CARD_STAT_KINDS.compliments:
      return `${wholeCount(value)} ${wholeCount(value) === 1 ? 'compliment' : 'compliments'}`
    case CARD_STAT_KINDS.bottles:
      return `${Math.max(1, wholeCount(value))} ${Math.max(1, wholeCount(value)) === 1 ? 'bottle' : 'bottles'}`
    case CARD_STAT_KINDS.lastWorn:
      return String(value || 'Recently')
    case CARD_STAT_KINDS.duration: {
      const hours = Math.round((Math.max(0, Number(value) || 0) / 3600) * 10) / 10
      return `${hours} ${hours === 1 ? 'hour' : 'hours'}`
    }
    default:
      return 'In collection'
  }
}

export function secondaryLineText(line) {
  return {
    [CARD_SECONDARY_LINES.firstWear]: 'First wear',
    [CARD_SECONDARY_LINES.earlyFavorite]: 'Early favorite',
    [CARD_SECONDARY_LINES.firstCompliment]: 'First compliment',
    [CARD_SECONDARY_LINES.gettingNoticed]: 'Getting noticed',
  }[line] || null
}
